import { tv } from 'tailwind-variants'

export const section = tv({
  base: 'flex flex-col px-6 py-12 md:p-12 lg:p-20',
})
